import { api } from './client';

export const authApi = {
    login: (email, password) =>
        api.post('/api/v1/auth/login', { email, password }),
    me: () => api.get('/api/v1/auth/me'),
    logout: () => api.post('/api/v1/auth/logout'),
    changePassword: (current_password, new_password) =>
        api.post('/api/v1/auth/change-password', { current_password, new_password }),
};

export const attendanceApi = {
    current: () => api.get('/api/v1/attendance/current'),
    recent: (days = 7) => api.get(`/api/v1/attendance/recent?days=${days}`),
    checkIn: (late_reason) =>
        api.post('/api/v1/attendance/check-in', { late_reason }),
    checkOut: (end_of_day_note) =>
        api.post('/api/v1/attendance/check-out', { end_of_day_note }),
    history: (start, end) =>
        api.get(`/api/v1/me/attendance?start=${start}&end=${end}`),
};

export const meApi = {
    getMyScreenshots: ({ start, end }) => {
        const q = new URLSearchParams({ start, end });
        return api.get(`/api/v1/me/screenshots?${q.toString()}`);
    },
};
